'use client';

import { useState, useEffect } from 'react';
import MetricsDashboard from './MetricsDashboard';
import PartnershipCTA from './PartnershipCTA';

interface ImpactFrameworkInteractiveProps {
  className?: string;
}

const ImpactFrameworkInteractive = ({ className = '' }: ImpactFrameworkInteractiveProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className={className}>
        <div className="animate-pulse space-y-8">
          <div className="h-96 bg-muted rounded-lg"></div>
          <div className="h-96 bg-background rounded-lg"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <MetricsDashboard />
      <PartnershipCTA />
    </div>
  );
};

export default ImpactFrameworkInteractive;